"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const Button_1 = __importStar(require("../Button"));
const DropdownNav_1 = require("app/Components/OnpageNavigation/DropdownNav");
const Disclaimer = ({ disclaimerState, setDisclaimerState, landingPageData, }) => {
    var _a, _b;
    const [residence, setResidence] = (0, react_1.useState)('');
    const allowedArray = landingPageData.showDisclaimer.value && ((_a = landingPageData.approvedRegions) === null || _a === void 0 ? void 0 : _a.value) ? Array.from((_b = landingPageData.approvedRegions) === null || _b === void 0 ? void 0 : _b.value) : null;
    (0, react_1.useEffect)(() => {
        if (residence !== '' && allowedArray && allowedArray.includes(residence)) {
            setDisclaimerState(1);
        }
        else if (residence !== '') {
            setDisclaimerState(3);
        }
    }, [residence]);
    const getDisclaimer = () => {
        var _a, _b, _c, _d;
        if (disclaimerState === 0)
            return react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(spa_core_1.Components.ContentArea, { animate: true, data: landingPageData.residenceContentArea, propertyName: "residenceContentArea", containerBackgroundColor: landingPageData.contentAreaBackgroundColor.value }),
                react_1.default.createElement("div", { className: 'row g-0 disclaimer' },
                    react_1.default.createElement("div", { className: 'block layout col-12' },
                        react_1.default.createElement("div", { className: 'mb-10' },
                            react_1.default.createElement("div", { className: 'row' },
                                react_1.default.createElement("div", { className: 'col-12 col-sm-8 col-md-6 col-xl-4' },
                                    react_1.default.createElement(DropdownNav_1.DropdownNav, { currentTitle: (_a = landingPageData.residenceSelectDefault) === null || _a === void 0 ? void 0 : _a.value, isSelect: true, selectLabel: (_b = landingPageData.residenceSelectLabel) === null || _b === void 0 ? void 0 : _b.value, selectOptions: Array.from(landingPageData.disclaimerRegions.value), selectState: residence, setSelectState: setResidence })))))));
        else if (disclaimerState === 1)
            return react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(spa_core_1.Components.ContentArea, { animate: true, data: landingPageData.disclaimerContentArea, propertyName: "disclaimerContentArea", containerBackgroundColor: landingPageData.contentAreaBackgroundColor.value }),
                react_1.default.createElement("div", { className: 'row g-0' },
                    react_1.default.createElement("div", { className: 'block layout col-12' },
                        react_1.default.createElement("div", { className: 'mb-6' },
                            react_1.default.createElement("div", { className: 'row mt-8 mb-10' },
                                react_1.default.createElement("div", { className: 'col-auto' },
                                    react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.Primary, onClick: () => setDisclaimerState(2), title: (_c = landingPageData.agreeButtonText) === null || _c === void 0 ? void 0 : _c.value })),
                                react_1.default.createElement("div", { className: 'col-auto' },
                                    react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.Primary, onClick: () => setDisclaimerState(3), title: (_d = landingPageData.disagreeButtonText) === null || _d === void 0 ? void 0 : _d.value })))))));
        else if (disclaimerState === 3)
            return react_1.default.createElement(spa_core_1.Components.ContentArea, { animate: true, data: landingPageData.notAllowedContentArea, propertyName: "notAllowedContentArea", containerBackgroundColor: landingPageData.contentAreaBackgroundColor.value });
    };
    return getDisclaimer();
};
exports.default = Disclaimer;
